import { render } from "./joinUs.vue?vue&type=template&id=0396313d&scoped=true"
import script from "./joinUs.vue?vue&type=script&lang=js"
export * from "./joinUs.vue?vue&type=script&lang=js"

import "./joinUs.vue?vue&type=style&index=0&id=0396313d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.32_vue@3.4.32_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0396313d"]])

export default __exports__